import { render, staticRenderFns } from "./SubmitItem.vue?vue&type=template&id=98878ffe"
import script from "./SubmitItem.vue?vue&type=script&lang=js"
export * from "./SubmitItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports